<template>
	<div class="change_mode_alert">
		<div class="change_mode_wrap">
			<div class="change_mode_cancel" @click="onCancelClick"></div>

			<div class="mode_title">当前设备不支持收益模式</div>
			<div class="mode_desc">请重新检测是否能开启收益模式</div>
			<div class="mode_icon"></div>
			<div class="mode_btn" @click="onReTestClick">重新检测</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onCancelClick: function () {
			this.$emit("onCancelClick");
		},
		onReTestClick: function () {
			this.$emit("onReTestClick");
		},
	},
};
</script>

<style lang="less" scoped>
.change_mode_alert {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
	.change_mode_wrap {
		width: 300px;
		height: 360px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -150px;
		margin-top: -180px;
		border-radius: 5px;
		overflow: hidden;
		background-color: #fcfcfc;
		.change_mode_cancel {
			width: 20px;
			height: 20px;
			background-image: url("../../assets/speedShare/alert_close.svg");
			background-size: 100% 100%;
			position: absolute;
			top: 15px;
			right: 20px;
		}
		.change_mode_cancel:hover {
			opacity: 0.8;
			cursor: pointer;
		}
		.mode_icon {
			height: 158px;
			width: 166px;
			margin: 0 auto;
			margin-top: 20px;
			background-image: url("../../assets/speedShare/unsupport_icon.svg");
			background-size: 100% 100%;
		}
		.mode_title {
			font-size: 17px;
			color: #1a1a1a;
			text-align: center;
			font-weight: bolder;
			margin-top: 55px;
		}
		.mode_desc {
			margin: 0 auto;
			margin-top: 5px;
			width: 236px;
			font-size: 12px;
			color: #e34421;
			text-align: center;
		}

		.mode_btn {
			margin: 0 auto;
			margin-top: 25px;
			border-radius: 20px;
			width: 115px;
			height: 36px;
			line-height: 36px;
			font-size: 14px;
			color: #fefefe;
			text-align: center;
			background-color: #1f5de3;
		}
		.mode_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}
	}
}
</style>